import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {Link} from 'react-router';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, FormattedMessage, FormattedNumber, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import RefreshButton from '../jobs/RefreshButton.react';

import './Fetch.scss';
import {renderTime} from "../flow-invocations/FlowInvocationList.react";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'fetchList.title', 'defaultMessage': 'List of API Requests'},
    serverTimestamp: { id: 'fetchView.timestamp', 'defaultMessage': 'Server time: {time}' },
    nameTitle: {id: 'fetches.name', 'defaultMessage': 'Operation name'},
    delay: {id: 'fetches.delay', 'defaultMessage': 'Delayed due to rate-limit'},
    delay: {id: 'fetches.delay', 'defaultMessage': 'Delayed due to rate-limit'},
    requestSourceTitle: {id: 'fetches.requestSource', 'defaultMessage': 'Request source'},
    searchName: {id: 'fetchList.searchName', 'defaultMessage': 'Search name'},
    searchRequest: {id: 'fetchList.searchRequest', 'defaultMessage': 'Search request'},
    searchResponse: {id: 'fetchList.searchResponse', 'defaultMessage': 'Search response'},
    createdAtAfter: {id: 'fetchList.createdAtAfter', 'defaultMessage': 'Created after'},
    createdAtBefore: {id: 'fetchList.createdAtBefore', 'defaultMessage': 'Created before'},
});

interface FetchListOrganisationProps {
 intl: IntlShape;
 relay?: object;
 user: User;
}

class FetchListOrganisation extends React.Component<FetchListOrganisationProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    typeName = 'fetches';
    listUrlPart = 'list-org'

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            loadingError: false,
        };
    }

    search = (event) => {
        this.setState({
            loading: true,
            loadingError: false,
        });

        let values = {};

        if (this.refs.searchNameBoxRef.value) {
            values["nameLike"] = this.refs.searchNameBoxRef.value;
        }
        if (this.refs.searchResponseBoxRef.value) {
            values["dataLike"] = this.refs.searchResponseBoxRef.value;
        }
        if (this.refs.searchRequestBoxRef.value) {
            values["requestLike"] = this.refs.searchRequestBoxRef.value;
        }
        if (this.refs.createdAtBeforeBoxRef.value) {
            let time = this.refs.createdAtBeforeTimeBoxRef.value || "23:59:59";
            values["createdAtBefore"] = this.refs.createdAtBeforeBoxRef.value + " " + time;
        }
        if (this.refs.createdAtAfterBoxRef.value) {
            let time = this.refs.createdAtAfterTimeBoxRef.value || "00:00:00";
            values["createdAtAfter"] = this.refs.createdAtAfterBoxRef.value + " " + time;
        }

        this.props.relay.setVariables(values, (state) => {
            if (state.done) {
                this.setState({
                    loading: false,
                    loadingError: false,
                });
            } else if (state.error) {
                this.setState({
                    loading: false,
                    loadingError: true,
                });
            }
        });
    }

    reset = () => {
        if (this.refs.searchNameBoxRef) {
            this.refs.searchNameBoxRef.value = "";
        }
        if (this.refs.searchRequestBoxRef) {
            this.refs.searchRequestBoxRef.value = "";
        }
        if (this.refs.searchResponseBoxRef) {
            this.refs.searchResponseBoxRef.value = "";
        }
        if (this.refs.createdAtAfterBoxRef) {
            this.refs.createdAtAfterBoxRef.value = "";
        }
        if (this.refs.createdAtBeforeBoxRef) {
            this.refs.createdAtBeforeBoxRef.value = "";
        }
        if (this.refs.createdAtAfterTimeBoxRef) {
            this.refs.createdAtAfterTimeBoxRef.value = "";
        }
        if (this.refs.createdAtBeforeTimeBoxRef) {
            this.refs.createdAtBeforeTimeBoxRef.value = "";
        }

        this.props.relay.setVariables({
            nameLike: "",
            dataLike: "",
            requestLike: "",
            createdAtAfter: "",
            createdAtBefore: "",
        });
    }

    render() {
        const {user} = this.props;
        let data = user.organisation;
        const list = data.fetches;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: data}]
            } className="fetchList" title={this.props.intl.formatMessage(messages.title)}>
                <h3><FormattedMessage defaultMessage="API Requests" id="fetches.list" /></h3>

                <div className="btn-toolbar" role="toolbar">
                    <RefreshButton relay={this.props.relay} />

                    <div aria-label="..." className="btn-group" role="group" style={{paddingRight: '1em'}}>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart, data)}><FormattedMessage defaultMessage="All" id="fetchList.listAll" /></Link>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart + '-success', data)}><FormattedMessage defaultMessage="Succeeded" id="fetchList.listSuccess" /></Link>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart + '-fail', data)}><FormattedMessage defaultMessage="Failed" id="fetchList.listFailed" /></Link>
                    </div>

                    <div className="input-group">
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtAfter)} ref="createdAtAfterBoxRef" style={{width: '11em'}}  type="date" />
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtAfter)} ref="createdAtAfterTimeBoxRef" style={{width: '5em'}} type="time" />
                    </div>
                    <div className="input-group">
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtBefore)} ref="createdAtBeforeBoxRef" style={{width: '11em'}}  type="date" />
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtBefore)} ref="createdAtBeforeTimeBoxRef" style={{width: '5em'}} type="time" />
                    </div>

                    <div className="input-group" style={{maxWidth: '200px'}}>
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.searchName)} ref="searchNameBoxRef" type="text" />
                    </div>

                    <div aria-label="..." className="btn-group" role="group" style={{paddingRight: '1em'}}>
                        <div className="input-group-btn">
                            <button className="btn btn-outline-secondary" onClick={this.search} type="button">{this.state.loading ? <span className="fa fa-refresh fa-spin"/> : (this.state.loadingError ? <span className="fa fa-exclamation" style={{color: 'red'}}/> : <span className="fa fa-search"/>)}</button>
                        </div>
                        <div className="input-group-btn">
                            <button className="btn btn-outline-secondary" onClick={this.reset} type="button"><span className="fa fa-times"/></button>
                        </div>
                    </div>
                </div>

                <PagingGrid
                    columns={{
                        'channelDef': {
                            header: (<span></span>),
                            render: (column, item) => {
                                if (item.channelDef) {
                                    return <ChannelIcon channelDef={item.channelDef} size={32} />;
                                }

                                return null;
                            }
                        },
                        'createdAt': {
                            render: (column, item) => {
                                return renderTime(item, column);
                            }
                        },
                        'success': {
                            className: (item) => {
                                if (item.ignoredError) {
                                    return "ignoredErrorValue";
                                }
                                return item.success ? 'successValue' : 'unsuccessValue';
                            },
                            render: (column, item) => {
                                if (item[column] === true && !item.ignoredError) {
                                    return <FormattedMessage defaultMessage="yes" id="Tool.smallYes" />;
                                }

                                return <FormattedMessage defaultMessage="{errorType} - {error}" id="Common.dashJoin" values={{errorType: item.errorType, error: item.error}} />;
                            }
                        },
                        'duration': {
                            render: (column, item) => {
                                return (
                                    <span style={{width: '40px', textAlign: 'right', display: 'inline-block'}}>
                                        <FormattedNumber value={item[column]} />&nbsp;ms {item['delay'] > 0 ? <span style={{"whiteSpace": "nowrap"}}><span className="fa fa-clock-o" title={this.props.intl.formatMessage(messages.delay)} />&nbsp;<FormattedNumber value={item['delay'] / 1000} />&nbsp;s</span> : null}
                                    </span>
                                );
                            }
                        },
                        'requestSource': {
                            withoutMapping: true,
                            showAlways: true,
                            header: (
                                <span title={this.props.intl.formatMessage(messages.requestSourceTitle)}>
                                    <FormattedMessage defaultMessage="Request source" id="fetches.requestSource" />
                                </span>
                            ),
                            render: (column, item) => {
                                return (
                                    <span style={{textAlign: 'left', display: 'inline-block'}}>
                                        {[
                                            item.actionDef ? item.actionDef.name : '',
                                            item.sourceDef ? item.sourceDef.name : '',
                                            item.flow ? item.flow.name : '',
                                            item.flowDef ? item.flowDef.name : '',
                                            item.flowStepDef ? item.flowStepDef.name : '',
                                            item.name ? item.name : '',
                                        ].filter((a) => !!a).join(" | ")}
                                    </span>
                                );
                            }
                        }
                    }}
                    edges={list}
                    getUrl={(row, column) => {
                        if (!row.channel_id) {
                            return urlMapping.getUrl('fetches', 'view2', row);
                        }
                        return urlMapping.getUrl('fetches', 'view', row);
                    }}
                    metadata={type}
                    pageInfo={list.pageInfo}
                    relay={this.props.relay}
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FetchListOrganisation), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
        success: null,
        requestLike: null,
        nameLike: null,
        dataLike: null,
        createdAtBefore: null,
        createdAtAfter: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        if (variables.success) {
            if (variables.success === "fail") {
                variables.success = false;
            } else {
                variables.success = true;
            }
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    fetches(first: $first, after: $after, before: $before, last: $last, success: $success, requestLike: $requestLike, dataLike: $dataLike, nameLike: $nameLike, createdAtBefore: $createdAtBefore, createdAtAfter: $createdAtAfter) {
                        edges {
                            node {
                                createdAt,
                                success,
                                id,
                                realId,
                                duration,
                                delay,
                                ignoredError,
                                error,
                                errorType,
                                channel_id,
                                channel {
                                    id,
                                    name,
                                    channelDef {
                                        id,
                                        name,
                                        icon,
                                    }
                                },
                                channelDef {
                                    id,
                                    name,
                                    icon,
                                },
                                organisation {
                                    id,
                                    name,
                                }
                                organisation_id,
                                sourceDef {
                                    name,
                                    id
                                },
                                actionDef {
                                    name,
                                    id
                                },
                                flowDef {
                                    name,
                                    id
                                },
                                flowStepDef {
                                    name,
                                    id
                                },
                                flow {
                                    name,
                                    id,
                                    flowDef {
                                        id,
                                        name,
                                    },
                                },
                                name
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
